import React, { useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { startHostedResults } from '../firebase/venues'
import { makeHostedUrl } from '../components/helpers'
import { getIsFetching, setIsFetching, setSearchResults } from '../store/search'
import { getUser } from '../store/user'

import RequireUser from '../components/RequireUser'
import HostView from '../components/SearchVenues/HostView'
import Loading from '../components/Loading'

const PageHostedVenues = () => {
  const dispatch = useDispatch()
  const isFetching = useSelector(getIsFetching)
  const user = useSelector(getUser)

  useLayoutEffect(() => {
    startHostedResults({
      setFetching(value) {
        dispatch(setIsFetching(value))
      },
      setSearchResults(results) {
        dispatch(setSearchResults(results))
      },
      user,
    })
  }, [])

  if (isFetching) {
    return <Loading />
  }

  return (
    <HostView
      makeUrl={makeHostedUrl}
    />
  )
}

export default () => (
  <RequireUser>
    <PageHostedVenues />
  </RequireUser>
)
